<iahoy-modal-layout>
  <ng-container header-title>Privacidad y analítica</ng-container>
  <ng-container header-description>Elige si permites la analítica y el diagnóstico del portal.</ng-container>
  <ng-container body>
    <span class="modal-copy text-sm">
      La analítica nos ayuda a entender cómo se usa el portal y a mejorar la experiencia. Puedes permitirla o
      desactivarla cuando quieras.
    </span>

    <div class="modal-preference">
      <iahoy-checkbox [label]="'Permitir analítica y diagnóstico'" [formControl]="analyticsControl"></iahoy-checkbox>
      <span class="modal-preference__description text-sm">
        Nos ayuda a detectar incidencias y a priorizar mejoras sobre datos reales.
      </span>
    </div>

    <iahoy-link-button
      text="Ver política de cookies"
      [href]="cookiePolicyUrl"
      [target]="'_blank'"
      [removeSpacing]="true"
    ></iahoy-link-button>
    <iahoy-link-button
      text="Ver política de privacidad"
      [href]="privacyPolicyUrl"
      [target]="'_blank'"
      [removeSpacing]="true"
    ></iahoy-link-button>
  </ng-container>
  <ng-container actions>
    <iahoy-button mat-dialog-close [variant]="'no-outline'" text="Cancelar" (click)="close()"></iahoy-button>
    <iahoy-button text="Guardar" variant="accent" [disabled]="!hasSelectionChanged()" (click)="save()"></iahoy-button>
  </ng-container>
</iahoy-modal-layout>
